import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { fetchReturns, forceReturnValidation } from "../actions/returns";
import { requestApayout } from "../actions/payouts";
import { FormattedPrice } from "clorian-frontend-components";
import Notification from "../components/structure/Notification";
import { Overlay } from "clorian-frontend-components";
import "react-dates/initialize";
import { DateRangePicker } from "react-dates";
import "react-dates/lib/css/_datepicker.css";
import "../resources/stylesheets/returns.css";
import {
  getTableColumns,
  getTableOptions,
} from "../table-management/returns-table/table-configs";
import { TableContainer } from "../components/structure/TableContainer";
import Cookie from "js-cookie";

class ReturnsContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      returnList: [],
      initialReturnList: [],
      pageOfItems: [],
      minimumPayout: 0,
      payoutValidation: false,
      showNotification: false,
      notification: {
        status: "",
        message: "",
        title: "",
      },
      sort: "asc",
      startDate: null,
      endDate: null,
      finishLoad: false,
      view: "all",
    };

    this.hideColumn = {
      display: "none",
    };

    this.handlePayoutRequest = this.handlePayoutRequest.bind(this);
    this.changeDates = this.changeDates.bind(this);
    this.changeReturnStatus = this.changeReturnStatus.bind(this);
    this.forceValidation = this.forceValidation.bind(this);
  }

  componentDidMount() {
    const { currentAffiliate } = this.props;
    if (currentAffiliate) {
      this.fetchReturny(
        currentAffiliate.clientId,
        currentAffiliate.affiliateId
      );
    }
  }

  fetchReturny(clientId, affiliateId) {
    const { dispatch } = this.props;

    if (clientId && affiliateId) {
      dispatch(
        fetchReturns({ clientId: clientId, affiliateId: affiliateId })
      ).then(({ response }) => {
        if (response && response.affiliateReturnVoList) {
          this.setState({
            payoutValidation: response.payoutValidation,
            returnList: response.affiliateReturnVoList,
            initialReturnList: response.affiliateReturnVoList,
            minimumPayout: response.minimunPayout,
            finishLoad: true,
          });
        } else {
          this.setState({
            returnList: [],
            payoutValidation: false,
            minimumPayout: 0,
            finishLoad: true,
          });
        }
      });
    } else {
      this.setState({
        finishLoad: true,
      });
    }
  }

  componentDidUpdate(prevProps) {
    const prevAffiliate = prevProps.currentAffiliate || {};
    const prevClientId = prevProps.clientId;

    const currAffiliate = this.props.currentAffiliate || {};
    const currClientId = this.props.clientId;

    if (
      currAffiliate.affiliateId !== prevAffiliate.affiliateId ||
      currClientId !== prevClientId
    ) {
      this.fetchReturny(currClientId, currAffiliate.affiliateId);
    }
  }

  handlePayoutRequest() {
    const { dispatch, clientId, currentAffiliate } = this.props;
    const { payoutValidation, initialReturnList } = this.state;

    let returnIdList = [];

    if (payoutValidation) {
      initialReturnList
        .filter((r) => r.valid)
        .forEach((obj) => returnIdList.push(obj.returnId));
    } else {
      initialReturnList.forEach((obj) => {
        returnIdList.push(obj.returnId);
      });
    }

    if (currentAffiliate) {
      dispatch(requestApayout(returnIdList, currentAffiliate.affiliateId)).then(
        ({ response }) => {
          if (response) {
            this.setState({
              showNotification: true,
              notification: {
                title: "Success",
                message: "Your payout request has been sent",
                status: "success",
              },
            });
          } else {
            this.setState({
              showNotification: true,
              notification: {
                title: "Error",
                message:
                  "Your payout request has been unsuccessful. Please try again!",
                status: "danger",
              },
            });
          }
          this.fetchReturny(clientId, currentAffiliate.affiliateId);
        }
      );
    }
  }

  changeDates({ startDate, endDate }) {
    const { view } = this.state;
    this.manageFilters(startDate, endDate, view);
  }

  changeReturnStatus = (event) => {
    const { startDate, endDate } = this.state;
    this.manageFilters(startDate, endDate, event.target.value);
  };

  manageFilters(startDate, endDate, view) {
    const { initialReturnList } = this.state;
    let returns = initialReturnList;

    if (startDate && endDate) {
      returns = initialReturnList.filter((eachReturn) => {
        if (
          new Date(eachReturn.creationDate) >= startDate.startOf("day") &&
          new Date(eachReturn.creationDate) <= endDate.endOf("day")
        )
          return eachReturn;
        return false;
      });
    }

    if (view !== "all")
      returns = returns.filter((r) => String(r.valid).toLowerCase() === view);

    this.setState({
      startDate,
      endDate,
      returnList: returns,
      view,
    });
  }

  forceValidation(returnId) {
    const { dispatch, clientId, currentAffiliate } = this.props;

    if (returnId) {
      dispatch(forceReturnValidation(returnId)).then((response) => {
        if (response.response === 1) {
          this.setState({ showNotification: false });
          this.fetchReturny(clientId, currentAffiliate.affiliateId);
        } else {
          this.setState({
            showNotification: true,
            notification: {
              status: "danger",
              message: response.error.message,
              title: "Error",
            },
          });
        }
      });
    }
  }

  render() {
    const { payoutProcessing, dispatch, currency } = this.props;
    const {
      returnList,
      minimumPayout,
      showNotification,
      notification,
      payoutValidation,
      initialReturnList,
      finishLoad,
    } = this.state;

    const tableColumns = getTableColumns(
      payoutValidation,
      this.forceValidation,
      currency
    );
    const tableOptions = getTableOptions(dispatch);
    const locale = Cookie.get("locale") || "en";

    let returnsTotal = 0;
    let invalidReturnsTotal = 0;
    let payoutDisabled = true;

    if (initialReturnList && initialReturnList.length > 0) {
      initialReturnList.forEach((ret) => {
        if (payoutValidation && ret.valid) {
          returnsTotal += ret.returnValue;
        } else if (payoutValidation && !ret.valid) {
          invalidReturnsTotal += ret.returnValue;
        } else if (!payoutValidation) {
          returnsTotal += ret.returnValue;
        }
      });
      payoutDisabled = returnsTotal < minimumPayout;
    }

    const options = [
      { value: "all", label: "All" },
      { value: true, label: "Valid" },
      { value: false, label: "Invalid" },
    ];

    return (
      <div className="container">
        {showNotification && <Notification notification={notification} />}

        {payoutProcessing || !finishLoad ? (
          <Overlay noClorian={true} loading={true} />
        ) : (
          <Fragment>
            <div className="row mainBody">
              <div className="form-custom">
                <div className="form-group col-xs-12 col-sm-12 col-lg-6">
                  <label> Select return status :</label>
                  {/*                    <Select defaultValue={options[0]}
                              className="returnStatusSelect"
                              options={options}
                              onChange={this.changeReturnStatus}/>*/}
                  <select
                    className="form-control"
                    value={this.state.view}
                    onChange={this.changeReturnStatus}
                  >
                    {options.map((option) => (
                      <option
                        key={`option-${option.value}`}
                        value={option.value}
                      >
                        {option.label}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="form-group col-xs-12 col-sm-12 col-lg-6">
                  <label>Select Period :</label>
                  <DateRangePicker
                    startDate={this.state.startDate}
                    startDateId="your_unique_start_date_id"
                    endDate={this.state.endDate}
                    endDateId="your_unique_end_date_id"
                    onDatesChange={({ startDate, endDate }) =>
                      this.changeDates({ startDate, endDate })
                    }
                    focusedInput={this.state.focusedInput}
                    onFocusChange={(focusedInput) =>
                      this.setState({ focusedInput })
                    }
                    isOutsideRange={() => false}
                    minimumNights={0}
                  />
                </div>
              </div>
            </div>

            <div className="custom-table block row">
              <TableContainer
                columns={tableColumns}
                data={returnList}
                options={tableOptions}
              />
            </div>

            <div>
              <div className="row returnInfoDiv">
                <p className="returnInfo">Valid Return Total : &nbsp;</p>
                <strong>
                  <FormattedPrice
                    value={returnsTotal}
                    currency={currency}
                    locale={locale}
                  />
                </strong>
                <br />

                {payoutValidation ? (
                  <Fragment>
                    <p className="returnInfo">Invalid Return Total : &nbsp;</p>
                    <strong>
                      <FormattedPrice
                        value={invalidReturnsTotal}
                        currency={currency}
                        locale={locale}
                      />
                    </strong>
                    <br />
                  </Fragment>
                ) : null}

                <p className="returnInfo">Minimum payout : &nbsp;</p>
                <strong>
                  <FormattedPrice
                    value={minimumPayout}
                    currency={currency}
                    locale={locale}
                  />
                </strong>
                <br />

                <button
                  className="btn linkButtons"
                  disabled={payoutDisabled}
                  onClick={this.handlePayoutRequest}
                >
                  <span>Request Payout</span>
                </button>
              </div>
            </div>
          </Fragment>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { affiliates, payouts, clients } = state;
  const { clientList } = clients;
  let clientIndex = clientList.findIndex(
    (el) => el.clientId === affiliates.currentAffiliate.clientId
  );
  const sCurrency =
    clientIndex !== -1
      ? clientList[clientIndex].currencyList[0].isoCode
      : "EUR";

  return {
    currentAffiliate: affiliates.currentAffiliate,
    clientId: affiliates.currentAffiliate.clientId,
    payoutProcessing: payouts.isProcessing,
    currency: sCurrency,
  };
};

ReturnsContainer = connect(mapStateToProps)(ReturnsContainer);

export default ReturnsContainer;
